(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMobileNav() {
    /* ══════════════════════════════════
       1. MENU → Theme's header drawer
    ══════════════════════════════════ */
    var menuBtn = document.getElementById('mob-nav-menu-btn');
    if (menuBtn) {
      menuBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var details = document.getElementById('Details-menu-drawer-container');
        if (!details) {
          var targets = [
            'header-drawer details',
            '.menu-drawer-container',
            '#Details-menu-drawer-container'
          ];
          for (var i = 0; i < targets.length; i++) {
            details = document.querySelector(targets[i]);
            if (details) break;
          }
        }

        if (details) {
          var headerDrawer = details.closest('header-drawer');
          var isOpen = details.hasAttribute('open');

          if (isOpen) {
            if (headerDrawer && typeof headerDrawer.close === 'function') {
              headerDrawer.close();
            } else {
              details.removeAttribute('open');
              details.classList.remove('menu-open');
            }
          } else {
            details.setAttribute('open', '');
            if (headerDrawer && typeof headerDrawer.open === 'function') {
              headerDrawer.open();
            } else {
              details.classList.add('menu-open');
            }
          }
        }
      });
    }

    /* ══════════════════════════════════
       2. CART → Theme's cart drawer
    ══════════════════════════════════ */
    var cartBtn = document.getElementById('mob-nav-cart-btn');
    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        var cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer) {
          if (typeof cartDrawer.open === 'function') { cartDrawer.open(); return; }
          if (typeof cartDrawer.showDialog === 'function') { cartDrawer.showDialog(); return; }
        }
        /* Fallback: click cart icon in header */
        var headerCartBtn = document.querySelector('.header-actions__action--cart, [data-cart-toggle], .cart-icon-button');
        if (headerCartBtn) { headerCartBtn.click(); return; }
        window.location.href = '/cart';
      });
    }

    /* ══════════════════════════════════
       3. SEARCH → Theme's search modal
       Theme: on:click="#search-modal/showDialog"
    ══════════════════════════════════ */
    var searchBtn = document.getElementById('mob-nav-search-btn');
    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        /* Click the header's search button — it handles all the dialog logic */
        var headerSearch = document.querySelector('search-button button');
        if (headerSearch) { headerSearch.click(); return; }

        /* Fallback: find dialog-component wrapping #search-modal and call showDialog */
        var searchDialog = document.getElementById('search-modal');
        if (searchDialog) {
          var dialogComp = searchDialog.closest('dialog-component');
          if (dialogComp && typeof dialogComp.showDialog === 'function') {
            dialogComp.showDialog();
            return;
          }
          /* Native dialog fallback */
          if (typeof searchDialog.showModal === 'function') searchDialog.showModal();
        }
      });
    }

    /* ══════════════════════════════════
       4. CART BADGE — live update
    ══════════════════════════════════ */
    document.addEventListener('cart:update', function (e) {
      var badge = document.getElementById('mob-nav-cart-count');
      if (!badge) return;
      var count = e.detail && e.detail.resource && e.detail.resource.item_count;
      if (count !== undefined) badge.textContent = count > 0 ? count : '';
    });

    /* ══════════════════════════════════
       5. WISHLIST BADGE — live update
    ══════════════════════════════════ */
    function updateWishlistBadge() {
      var badge = document.getElementById('mob-nav-wishlist-count');
      if (!badge) return;
      var count = 0;
      try {
        var raw = localStorage.getItem('astreabeauty_wishlist');
        if (raw) count = JSON.parse(raw).length;
      } catch (err) {}
      badge.textContent = count > 0 ? count : '';
    }
    updateWishlistBadge();
    document.addEventListener('wishlist:updated', updateWishlistBadge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNav);
  } else {
    initMobileNav();
  }

  document.addEventListener('shopify:section:load', initMobileNav);
})();

  } catch(e) { console.error(e); }
})();
})();
